module.exports = __webpack_public_path__ + "static/media/strength-m.0bcb39cd.svg";